import { combineReducers } from "redux";

import Procedure from "./Definition/Module";
import SearchProcedure from "./Search/Module";
const reducers = combineReducers({
  Procedure,
  SearchProcedure,
});

export default reducers;
